import { Icon } from '@dittolive/anvil'
import { ArrowUpRightIcon } from '@phosphor-icons/react'
import { useQuery } from '@tanstack/react-query'
import { SystemCollections } from 'components/dittoAppConnection'
import { useRPCHook } from 'components/hooks/rpc'
import paths from 'paths'
import { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { useFeatureFlags } from 'utils/featureFlags'

import { useAppManagementContext } from './context'

type Props = {
  databaseId: string
}

export default function AppForgeLink({ databaseId }: Props) {
  const { appForge } = useFeatureFlags()
  const { cloudDomainUrl: cloudUrl } = useAppManagementContext()
  const { executeDqlQuery, rpcAccessToken } = useRPCHook({
    appId: databaseId,
    cloudUrl,
  })

  const getProject = useCallback(async () => {
    const { items } = await executeDqlQuery(
      `SELECT * FROM ${SystemCollections.FORGE_APPS_COLLECTION} LIMIT 1`,
    )
    const projectID = items.at(0)?._id
    return typeof projectID === 'string' ? projectID : undefined
  }, [executeDqlQuery])

  const { data: appId } = useQuery({
    queryKey: ['forgeProject', databaseId],
    queryFn: getProject,
    enabled: !!rpcAccessToken,
  })

  const url = paths.forge({ databaseId, appId })

  if (!appForge) {
    return null
  }

  return (
    <Link
      to={url}
      className="bg-background-surface inline-flex shrink-0 items-center space-x-2 rounded-full py-1 pl-1 pr-3 shadow-sm"
      data-testid="forgeLink"
    >
      <span className="bg-primary text-foreground-on-brand-primary items-center justify-center rounded-full px-2 py-1 text-sm">
        Alpha
      </span>

      <div className="flex items-center space-x-1">
        <span>App builder</span>
        <Icon
          svg={<ArrowUpRightIcon />}
          className="text-foreground-subtle size-4"
        />
      </div>
    </Link>
  )
}
